export const convertCssAniDurationToMS = (cssAniDuration) => {
    let cssValue = cssAniDuration.replace("s", "");
    return parseFloat(cssValue) * 1000;
}

export const removeLengthUnitFromCssVar = (cssVariable) => {
    if(cssVariable.match("px")) {
        return cssVariable.replace("px", "")
    } else if (cssVariable.match("rem")) {
        let result = cssVariable.replace("rem", "");
        return result * 16;
    }
}

export const addClassForCloseAnimation = (element, classForAnima, animationTime) => {
    element.classList.add(classForAnima);
    setTimeout(() => {
        element.classList.remove(classForAnima);
    }, animationTime);
}